import { User } from 'types'
import { get, patch, post } from './helpers'
import { CreateUserOptions, UpdateUserOptions, UserResponse } from './types'

export const transformUserResponseToUser = (user: UserResponse): User => {
  return {
    id: user.id,
    email: user.email,
    firstName: user.first_name,
    lastName: user.last_name,
    profilePicture: user.profile_picture,
    pushToken: user.push_token,
    heightCM: user.height_cm,
    weightKG: user.weight_kg,
    unitPreference: user.unit_preference,
    chatToken: user.chat_token,
    subscription: user.subscription,
    preferences: user.preferences,
    birthday: user.birthday,
    gender: user.gender,
    bmrRange: user.bmr_range,
    streak: user.streak,
    highestStreak: user.highest_streak,
    timezone: user.timezone,
  }
}

export const createUser = async (data: CreateUserOptions): Promise<User> => {
  console.log('createUser: Initiating API call with data:', data)
  const response = await post<UserResponse>(`/users`, data)
  console.log('createUser: API call successful, response:', response)
  const user = transformUserResponseToUser(response)
  console.log('createUser: Transformed user:', user)
  return user
}

export const getUser = async (): Promise<User> => {
  console.log('getUser: Initiating API call to fetch user')
  try {
    const response = await get<UserResponse>(`/users`)
    const user = transformUserResponseToUser(response)
    console.log('getUser: Transformed user:', user)
    return user
  } catch (error) {
    console.error('getUser: API call failed, error:', error)
    throw error
  }
}

// Get User by email
export const getUserByEmail = async (email: string): Promise<User | null | any> => {
  console.log('getUserByEmail: Initiating API call with email:', email)
  const queryEmail = encodeURIComponent(email)
  let user = await get(`/admin/users?email=${queryEmail}`)
  // throw error if not found or null
  if (!user) {
    console.log('User not found')
    throw new Error('User not found')
  }
  user = transformUserResponseToUser(user as UserResponse)
  console.log('getUserByEmail: Transformed user:', user)
  return user
}

export const updateUser = async (data: UpdateUserOptions): Promise<User> => {
  console.log('updateUser: Initiating API call with data:', data)
  const response = await patch<UserResponse>(`/users`, data)
  console.log('updateUser: API call successful, response:', response)
  const user = transformUserResponseToUser(response)
  console.log('updateUser: Transformed user:', user)
  return user
}
